import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { LanguageProvider } from "./context/LanguageContext";
import { initAnalytics } from "./lib/analytics";
import Navbar from "./components/Navbar";
import Hero from "./components/Hero";
import Marquee from "./components/Marquee";
import Services from "./components/Services";
import ResultsGallery from "./components/ResultsGallery";
import HowItWorks from "./components/HowItWorks";
import Reviews from "./components/Reviews";
import IstanbulSection from "./components/IstanbulSection";
import Faq from "./components/Faq";
import ConsultationForm from "./components/ConsultationForm";
import Footer from "./components/Footer";
import FloatingWhatsApp from "./components/FloatingWhatsApp";

const Site = () => (
  <div className="bg-ivory font-sans text-ink antialiased">
    <Navbar />
    <main>
      <Hero />
      <Marquee />
      <Services />
      <ResultsGallery />
      <HowItWorks />
      <Reviews />
      <IstanbulSection />
      <Faq />
      <ConsultationForm />
    </main>
    <Footer />
    <FloatingWhatsApp />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.2, anchors: true });
    let rafId;
    const loop = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(loop);
    };
    rafId = requestAnimationFrame(loop);
    initAnalytics();
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <LanguageProvider>
      <Site />
      <Toaster position="bottom-center" richColors />
    </LanguageProvider>
  );
}

export default App;
